import { FormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { FormField, FormFieldset } from '@domgen/dgx-fe-forms/layout';

export interface CmsPersonFieldset extends FormFieldset {
  addressFieldset: FormOverrideAddressFieldset;
  firstNameField: FormField;
  lastNameField: FormField;
  titleIdField: FormField;
}
